import { useEffect } from "react";
import { PricingTeaser } from "@/components/sections/PricingTeaser";
import { FAQ } from "@/components/sections/FAQ";
import { FinalCTA } from "@/components/sections/FinalCTA";

export default function PricingPage() {
  useEffect(() => {
    document.title = "Pricing — MACHA";
  }, []);

  return (
    <>
      <section className="border-b border-border bg-background">
        <div className="mx-auto w-full max-w-6xl px-5 py-20 text-center sm:px-8 sm:py-24">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">
            Pricing
          </p>
          <h1 className="mx-auto mt-3 max-w-2xl text-balance text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
            Pricing that scales with your client list — not the other way around.
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-muted-foreground">
            Start free. Upgrade only when MACHA is already paying for itself.
          </p>
        </div>
      </section>
      <PricingTeaser />
      <FAQ />
      <FinalCTA />
    </>
  );
}
